export { createPromotionSideBlock };
import { imp } from '../../helpers/gtm';

function createPromotionSideBlock(data) {
  const messageTitle = data.col[0];
  const messageLink = data.col[1];
  const messageSrc = data.col[2];
  const messageSponsor = data.col[3];
  const $block = document.createElement('a');
  $block.classList.add('clickCL-box_side_presentpr', 'article');
  $block.href = messageLink;
  {
    const $figure = document.createElement('figure');
    $figure.classList.add('is-article-img-trim');
    {
      const $img = document.createElement('img');
      $img.classList.add('is-article-img');
      $img.src = messageSrc;
      $img.alt = messageTitle;
      $img.setAttribute('width', '100%');
      $img.setAttribute('height', 'auto');
      $figure.appendChild($img);
    }
    $block.appendChild($figure);
  }
  {
    const $div = document.createElement('div');
    $div.classList.add('is-article-title', 'title', 'is-4');
    const $p = document.createElement('p');
    $p.textContent = messageTitle;
    $div.appendChild($p);
    $block.appendChild($div);
  }
  {
    const $span = document.createElement('span');
    $span.classList.add('is-article-sponsor', 'label-round', 'is-pr', 'text-right');
    $span.textContent = messageSponsor;
    $block.appendChild($span);
  }
  return imp($block, messageTitle);
}
